import { ApiProperty } from '@nestjs/swagger';
export class HarvestDto {
    @ApiProperty()
    plantId: number;
    @ApiProperty()
    harvestDate: Date;
    @ApiProperty()
    farmerData: string;
    @ApiProperty()
    harvestTime: string;
    @ApiProperty()
    product: string;
    @ApiProperty()
    quantity: number;
    @ApiProperty()
    temperature1: string;
    @ApiProperty()
    temperature2: string;
    @ApiProperty()
    temperature3: string;
    @ApiProperty()
    temperature4: string;
    @ApiProperty()
    temperature5: string;
    @ApiProperty()
    cleanBoxes: boolean;
    @ApiProperty()
    hygineHandle: boolean;
    @ApiProperty()
    healthyShirmps: boolean;
    @ApiProperty()
    chillKilled: boolean;
    @ApiProperty()
    properIcing: boolean;
    @ApiProperty()
    vehicleNo: string;
    @ApiProperty()
    driverName: string;
    @ApiProperty()
    vehicleLeavingTime: string;
    @ApiProperty()
    remarks: string;
    @ApiProperty()
    indentId: number;
    @ApiProperty()
    indentItemId: number;
    @ApiProperty()
    createdUser: string;
    @ApiProperty()
    sealNo: string;
}